/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{margin:0}p.warning[_ngcontent-%COMP%]{color:#e30c1a}"];
export { styles as styles };
